import React from 'react';

// The list of input fields (by accessionKey) that are handled by this component
const validProfileSpecificFieldAccessionKeys = [
	'Collection Time #1',
	'Collection Time #2',
	'Collection Time #3',
	'Collection Time #4',
	'Collection Time #5'
];

export default function CollectionTimeFields({ form, onChange }) {
	if (!form || !form['Collection Time #1']) {
		return null;
	}

	return (
		<div id="collectionTimeFields" className="col-md-12">
			<table>
				<tbody>
					{validProfileSpecificFieldAccessionKeys.map((key, index) => {
						const item = form[key];
						if (!item) {
							return null;
						}

						const description = key;

						return (
							<tr key={key}>
								<td className="pr-20">
									<strong>
										{description}
										<span className="text-danger">*</span>
									</strong>
								</td>
								<td>
									<input
										type="time"
										name="sample-time"
										pattern="[0-9]{2}:[0-9]{2}[A-Z]{2}"
										value={item.value}
										data-accessionkey={key}
										onChange={onChange}
									/>
									{item.valid === false && (
										<span className="validation-message text-danger pl-10">
											Please fill out this field.
										</span>
									)}
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}